import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { useDocumentTitle } from '../utils/useDocumentTitle';
const DEFAULT_TERMS = `1. Los pedidos deben realizarse antes de la hora de corte establecida.

2. Una vez confirmado el pedido, no se permiten cambios ni cancelaciones después de 5 minutos.

3. Los subsidios aplicados son responsabilidad de la empresa contratante.

4. Los precios incluyen ITBIS (18%) salvo empresas exentas.

5. Las reclamaciones deben realizarse dentro de las 24 horas posteriores a la entrega.

6. El servicio de entrega está sujeto a disponibilidad y horarios establecidos.

7. La empresa se reserva el derecho de modificar el menú sin previo aviso.

8. Los datos personales serán tratados conforme a la ley de protección de datos de República Dominicana.`;
export function TermsPage() {
  useDocumentTitle('Términos y Condiciones | Cricket');
  const termsContent = localStorage.getItem('criket_terms') || DEFAULT_TERMS;
  return <div className="min-h-screen bg-white" data-id="element-6002">
      <div className="max-w-3xl mx-auto px-6 py-12" data-id="element-6003">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-gray-400 hover:text-gray-900 transition-colors mb-10" data-id="element-6004">
          <ArrowLeft className="w-4 h-4" data-id="element-6005" />
          Volver al inicio
        </Link>

        <div className="flex items-center gap-3 mb-8" data-id="element-6006">
          <div className="p-2.5 bg-gray-100 rounded-xl" data-id="element-6007">
            <FileText className="w-6 h-6 text-gray-700" data-id="element-6008" />
          </div>
          <div data-id="element-6009">
            <h1 className="text-3xl font-bold text-gray-900 tracking-tight" data-id="element-6010">
              Términos y Condiciones
            </h1>
            <p className="text-sm text-gray-400 mt-1" data-id="element-6011">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-DO', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>
          </div>
        </div>

        <div className="prose prose-gray max-w-none" data-id="element-6012">
          <div className="text-gray-700 whitespace-pre-wrap leading-relaxed text-base" data-id="element-6013">
            {termsContent}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-100" data-id="element-6014">
          <div className="flex items-center gap-2" data-id="element-6015">
            <img src="https://i.imgur.com/bxPZvDb.png" alt="Cricket Logo" className="h-7 w-auto object-contain" data-id="element-6016" />
          </div>
          <p className="text-xs text-gray-400 mt-3" data-id="element-6017">
            © {new Date().getFullYear()} Cricket. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </div>;
}